/* eslint-disable no-useless-escape */
/* eslint-disable no-control-regex */

// Copied from https://github.com/sebmarkbage/react/blob/c8979c016814a120dcd56ef4e26a20802c3e60d7/packages/react-dom/src/shared/sanitizeURL.js#L30
// This won't be needed in a future version of React
const isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i

/**
 * Removes javascript: eval's from URLs
 * @param url The url to sanitize
 */
export default function sanitizeURL(url: string) {
  if (isJavaScriptProtocol.test(url)) {
    return ''
  }

  return url
}
